import { styled } from '@mui/material'
import { NotificationsIndicator } from 'components/buttons'
import { CommonToggleButtonProps, StandardToggleButton } from './TooggleButton'

const NotificationWrapper = styled('div')(({ theme }) => ({
    position: 'absolute',
    transform: 'translate(15px, -20px) scale(0.8)',
    fontWeight: 600
}))

const ChatIconButton: React.FC<CommonToggleButtonProps & { notifications?: number }> = ({ id, active, disabled, onClick, notifications }) => (
    <StandardToggleButton
        id={id}
        color={active ? 'primary' : 'secondary'}
        icon={'ChatRounded'}
        disabled={disabled}
        onClick={onClick}
        selected={active}
    >
        {notifications && !disabled ? (
            <NotificationWrapper>
                <NotificationsIndicator id='chat-button-notifications-indicator'>
                    {notifications < 10 ? notifications : '9+'}
                </NotificationsIndicator>
            </NotificationWrapper>
        ) : null}
    </StandardToggleButton>
)

export { ChatIconButton }
